export default __webpack_public_path__ + "img/e2198c15c8047def2c9f3664f7097e77.png";